/**
 * The tab's title as the page changes inside the app. A full load gets its <title> from the server (server.js
 * renderEmberPage: a public page's from edge seo/spa-metadata.js, a private page none, so index.html's "Ember");
 * moving between pages in the app never touched it, so the tab kept the first page's title for the whole visit.
 * This says what a full load of the same address would say (tests/web/page-title.test.js holds it to the server's).
 */

const HOME_TITLE = 'Ember: Talk It Out — someone to talk to who gets it';
const PUBLIC_TITLES: Readonly<Record<string, string>> = Object.freeze({
  '/': HOME_TITLE,
  '/talk': 'Talk to Ember — Say what’s really on your mind',
  '/auth': 'Sign in to Ember',
  '/feedback': 'Send the Ember team a message',
});
/** A place's page without its own data in hand (its full load names the place). */
const PLACE_TITLE = 'A place many people have stood | Ember';
/** Every private page, as index.html names it. */
export const PRIVATE_TITLE = 'Ember';

/** The title a full load of `path` (no query) would carry, short of a place's own name. */
export function documentTitleFor(path: string): string {
  const own = PUBLIC_TITLES[path];
  if (own) return own;
  if (/^\/places\/[^/]+$/.test(path)) return PLACE_TITLE;
  return PRIVATE_TITLE;
}
